import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { DconfigCoreSettings } from '../dconfig-core.settings';

@Injectable({
  providedIn: 'root'
})
export class SystemService {

  private appsUrlBase = DconfigCoreSettings.API_ENDPOINT + '/DConfig/AppsAPI';
  private settingsUrlBase = DconfigCoreSettings.API_ENDPOINT + '/DConfig/SettingsAPI';
  private membershipUrlBase = DconfigCoreSettings.API_ENDPOINT + '/Membership';

  constructor(private http: HttpClient) { }

  getApps () : Observable<Object> {
    return this.http.get(this.appsUrlBase + '/GetApps');
  };
  getDesktopWidgets () : Observable<Object> {
    return this.http.get(this.appsUrlBase +'/GetDesktopWidgets');
  };
  getGeneralSettings () : Observable<Object> {
    return this.http.get(this.settingsUrlBase + '/getGeneralSettings');
  };
  getCustomSettings(key): Observable<Object> {
    return this.http.get(this.settingsUrlBase + '/getCustomSettings?Key=' + key);
  };
  updateGeneralSettings (obj) : Observable<Object> {
    return this.http.put(this.settingsUrlBase + '/updateGeneralSettings', obj);
  };
  updateCustomSettings(obj): Observable<Object> {
    return this.http.put(this.settingsUrlBase + '/updateCustomSettings', obj);
  };
  getEmailSettings () : Observable<Object> {
    return this.http.get(this.settingsUrlBase+ '/getEmailSettings');
  };
  getSMSSettings () : Observable<Object> {
    return this.http.get(this.settingsUrlBase + '/getSMSSettings');
  };
  updateEmailSettings (obj) : Observable<Object> {
    return this.http.put(this.settingsUrlBase + '/updateEmailSettings', obj);
  };
  updateSMSSettings (obj) : Observable<Object> {
    return this.http.put(this.settingsUrlBase + '/updateSMSSettings', obj);
  };
  getIdentitySettings () : Observable<Object> {
    return this.http.get(this.settingsUrlBase + '/getIdentitySettings');
  };
  updateIdentitySettings (obj) : Observable<Object> {
    return this.http.put(this.settingsUrlBase + '/updateIdentitySettings', obj);
  };
  getAppearanceSettings () : Observable<Object> {
    return this.http.get(this.settingsUrlBase + '/getAppearanceSettings');
  };
  updateAppearanceSettings (obj) : Observable<Object> {
    return this.http.put(this.settingsUrlBase + '/updateAppearanceSettings', obj);
  };
  getBackupSettings () : Observable<Object> {
    return this.http.get(this.settingsUrlBase + '/getBackupSettings');
  };
  updateBackupSettings (obj) : Observable<Object> {
    return this.http.put(this.settingsUrlBase + '/updateBackupSettings', obj);
  };
  getDatabaseSettings () : Observable<Object> {
    return this.http.get(this.settingsUrlBase + '/getDatabaseSettings');
  };
  updateDatabaseSettings (obj) : Observable<Object> {
    return this.http.put(this.settingsUrlBase + '/updateDatabaseSettings', obj);
  };
  getDateTimeSettings () : Observable<Object> {
    return this.http.get(this.settingsUrlBase + '/getDateTimeSettings');
  };
  updateDateTimeSettings (obj) : Observable<Object> {
    return this.http.put(this.settingsUrlBase + '/updateDateTimeSettings', obj);
  };
  getLanguagesSettings () : Observable<Object> {
    return this.http.get(this.settingsUrlBase + '/getLanguagesSettings');
  };
  updateLanguagesSettings (obj) : Observable<Object> {
    return this.http.put(this.settingsUrlBase + '/updateLanguagesSettings', obj);
  };
  getSecuritySettings () : Observable<Object> {
    return this.http.get(this.settingsUrlBase + '/getSecuritySettings');
  };
  updateSecuritySettings (obj) : Observable<Object> {
    return this.http.put(this.settingsUrlBase + '/updateSecuritySettings', obj);
  };
  getNotificationsSettings () : Observable<Object> {
    return this.http.get(this.settingsUrlBase + '/getNotificationsSettings');
  };
  updateNotificationsSettings (obj) : Observable<Object> {
    return this.http.put(this.settingsUrlBase + '/updateNotificationsSettings', obj);
  };
  getSystemInfoSettings () : Observable<Object> {
    return this.http.get(this.settingsUrlBase + '/getSystemInfoSettings');
  };
  updateSystemInfoSettings (obj) : Observable<Object> {
    return this.http.put(this.settingsUrlBase + '/updateSystemInfoSettings', obj);
  };
  getSystemUpdateSettings () : Observable<Object> {
    return this.http.get(this.settingsUrlBase + '/getSystemUpdateSettings');
  };
  updateSystemUpdateSettings (obj) : Observable<Object> {
    return this.http.put(this.settingsUrlBase + '/updateSystemUpdateSettings', obj);
  };
  getSupportSettings () : Observable<Object> {
    return this.http.get(this.settingsUrlBase + '/getSupportSettings');
  };
  updateSupportSettings (obj) : Observable<Object> {
    return this.http.put(this.settingsUrlBase + '/updateSupportSettings', obj);
  };
  getLogsSettings () : Observable<Object> {
    return this.http.get(this.settingsUrlBase + '/getLogsSettings');
  };
  getLogFile = function (logFile) : Observable<Object> {
    return this.http.get(this.settingsUrlBase + '/getLogFile?logFile=' + logFile);
  };
  getUserCompanies () : Observable<Object> {
    return this.http.get(this.membershipUrlBase + '/getUserCompanies');
  };
  setCurrentContext = function (id) : Observable<Object> {
    return this.http.put(this.membershipUrlBase + '/setCurrentContext/' + id);
  };
}
